var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container feedback template-bg-gray comm-req-page" },
    [
      _vm.showNotFound
        ? _c("NotFound", { attrs: { community_id: _vm.community_id } })
        : _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c("div", { staticClass: "card form-wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "feedback_container feedback_newupdate"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm.isShow
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12 text-center" },
                                    [
                                      _c("img", {
                                        staticClass: "top-logo custom-logo",
                                        attrs: {
                                          src: _vm.logoURL,
                                          alt:
                                            "Community Logo of " +
                                            (_vm.community &&
                                            _vm.community.content &&
                                            _vm.community.content.parameter4
                                              ? _vm.community.content.parameter4
                                              : (_vm.community &&
                                                  _vm.community.name) ||
                                                "Community")
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("CustomSkeleton", {
                                attrs: { "is-visible": !_vm.isShow }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isBeforeRequest && _vm.showFormFlag && _vm.isShow
                            ? [
                                _c("div", {}, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-content",
                                      attrs: { id: "myTabContent" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isFirstPage,
                                              expression: "isFirstPage"
                                            }
                                          ],
                                          staticClass: "tab_inn",
                                          attrs: {
                                            "aria-live": "polite",
                                            "aria-atomic": "false"
                                          }
                                        },
                                        [
                                          _c(
                                            "h1",
                                            {
                                              staticClass:
                                                "template-title common-space-from-logo",
                                              attrs: { id: "requestHelpHeader" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            What do you need help with?\n                                            "
                                              ),
                                              _c("Tooltip", {
                                                attrs: {
                                                  content:
                                                    "This form will help us match you with the right experts in our community who can provide guidance on your specific question.",
                                                  "aria-label":
                                                    "Help with this form",
                                                  role: "button",
                                                  isInteractive: true
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.community.content &&
                                          _vm.community.content
                                            .requestIntroduction
                                            ? _c("p", {
                                                staticClass:
                                                  "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.sanitizeListHTML(
                                                      _vm.community.content
                                                        .requestIntroduction
                                                    )
                                                  )
                                                }
                                              })
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                },
                                                [
                                                  _vm._v(
                                                    "We need a little bit of information to match you to relevant experts in the community."
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "form",
                                            {
                                              staticClass: "template-form",
                                              attrs: {
                                                "data-vv-scope": "step-1"
                                              },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  _vm.viewSecondPage("step-1"),
                                                    _vm.handleFocusOnQuestionError()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "required-note template-label",
                                                  attrs: { id: "required-note" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Fields marked with an asterisk ("
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-symbol"
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    ") are required.\n                                                "
                                                  ),
                                                  _c("Tooltip", {
                                                    attrs: {
                                                      content:
                                                        "All fields with a red asterisk (*) must be filled out before you can proceed to the next step.",
                                                      "aria-label":
                                                        "Required fields information",
                                                      role: "button",
                                                      isInteractive: true
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row responsive-v3-class"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "firstName"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .firstName
                                                                    .labelName
                                                                ) + " "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .dynamicFields
                                                                    .first,
                                                                expression:
                                                                  "dynamicFields.first"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              },
                                                              {
                                                                name: "focus",
                                                                rawName:
                                                                  "v-focus"
                                                              }
                                                            ],
                                                            ref: "firstName",
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.first"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id: "firstName",
                                                              name: "first",
                                                              autocomplete:
                                                                "given-name",
                                                              placeholder: "",
                                                              required: "",
                                                              "aria-required":
                                                                "true",
                                                              "data-vv-validate-on":
                                                                "change"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .dynamicFields
                                                                  .first
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.dynamicFields,
                                                                    "first",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.dynamicFields.first = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.first"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.first')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.first"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "lastName"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .lastName
                                                                    .labelName
                                                                )
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .dynamicFields
                                                                    .last,
                                                                expression:
                                                                  "dynamicFields.last"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.last"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id: "lastName",
                                                              autocomplete:
                                                                "family-name",
                                                              name: "last",
                                                              placeholder: "",
                                                              required: "",
                                                              "aria-required":
                                                                "true",
                                                              "data-vv-validate-on":
                                                                "change"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .dynamicFields
                                                                  .last
                                                            },
                                                            on: {
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.dynamicFields,
                                                                    "last",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.dynamicFields.last = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.last"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.last')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.last"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "email"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .emailAddress
                                                                    .labelName
                                                                )
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "required-symbol"
                                                                },
                                                                [_vm._v(" *")]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .dynamicFields
                                                                    .email,
                                                                expression:
                                                                  "dynamicFields.email"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate.continues",
                                                                value:
                                                                  "required|email",
                                                                expression:
                                                                  "'required|email'",
                                                                modifiers: {
                                                                  continues: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control input-value pt-input input-focus",
                                                            class: {
                                                              "request-form-error-border": _vm.errors.has(
                                                                "step-1.email"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "email",
                                                              autocomplete:
                                                                "email",
                                                              id: "email",
                                                              name: "email",
                                                              placeholder: "",
                                                              required: "",
                                                              "aria-required":
                                                                "true",
                                                              "data-vv-validate-on":
                                                                "change"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .dynamicFields
                                                                  .email
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.checkMemberStatus,
                                                              input: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm.dynamicFields,
                                                                    "email",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                },
                                                                function(e) {
                                                                  return (_vm.dynamicFields.email = _vm.sanitizeInput(
                                                                    e.target
                                                                      .value
                                                                  ))
                                                                }
                                                              ]
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.email"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.email')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.email"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .memberRole &&
                                                  _vm.configureFields.memberRole
                                                    .include &&
                                                  _vm.configureFields.memberRole
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "memberRole"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .memberRole
                                                                        .labelName
                                                                    ) + " "
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "memberRole"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "memberRole"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('memberRole')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .memberRole,
                                                                      expression:
                                                                        "dynamicFields.memberRole"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  class: {
                                                                    "request-form-error-border": _vm.errors.has(
                                                                      "step-1.memberRole"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    name:
                                                                      "memberRole",
                                                                    id:
                                                                      "memberRole",
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "memberRole"
                                                                    )
                                                                      ? "true"
                                                                      : "false"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "memberRole",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select role"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .memberRole
                                                                      .memberValue,
                                                                    function(
                                                                      role
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: role,
                                                                          domProps: {
                                                                            value: role.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              role.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.memberRole"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.memberRole')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.memberRole"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .phoneNumber &&
                                                  _vm.configureFields
                                                    .phoneNumber.include &&
                                                  _vm.configureFields
                                                    .phoneNumber.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "template-label",
                                                                          attrs: {
                                                                            for:
                                                                              "phoneNumber"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .configureFields
                                                                                .phoneNumber
                                                                                .labelName
                                                                            ) +
                                                                              " "
                                                                          ),
                                                                          _vm.checkAndValidate1(
                                                                            "phoneNumber"
                                                                          )
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "required-symbol"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " *"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .dynamicFields
                                                                                  .phoneNumber,
                                                                              expression:
                                                                                "dynamicFields.phoneNumber"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate.continues",
                                                                              value:
                                                                                "" +
                                                                                _vm.checkAndValidate1(
                                                                                  "phoneNumber"
                                                                                ),
                                                                              expression:
                                                                                "`${checkAndValidate1('phoneNumber')}`",
                                                                              modifiers: {
                                                                                continues: true
                                                                              }
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-control input-value pt-input input-focus",
                                                                          class: {
                                                                            "request-form-error-border": _vm.errors.has(
                                                                              "step-1.phoneNumber"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            id:
                                                                              "phoneNumber",
                                                                            name:
                                                                              "phoneNumber",
                                                                            "data-vv-validate-on":
                                                                              "change",
                                                                            "aria-required": _vm.checkAndValidate1(
                                                                              "phoneNumber"
                                                                            )
                                                                              ? "true"
                                                                              : "false"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              _vm
                                                                                .dynamicFields
                                                                                .phoneNumber
                                                                          },
                                                                          on: {
                                                                            input: [
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm.dynamicFields,
                                                                                  "phoneNumber",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              },
                                                                              function(
                                                                                e
                                                                              ) {
                                                                                return (_vm.dynamicFields.phoneNumber = _vm.sanitizeInput(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                ))
                                                                              }
                                                                            ]
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value: _vm.errors.has(
                                                                                "step-1.phoneNumber"
                                                                              ),
                                                                              expression:
                                                                                "errors.has('step-1.phoneNumber')"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "error"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.errors.first(
                                                                                "step-1.phoneNumber"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .adviceArea &&
                                                  _vm.configureFields.adviceArea
                                                    .include &&
                                                  _vm.configureFields.adviceArea
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "adviceArea"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .adviceArea
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "adviceArea"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "adviceArea"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('adviceArea')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .adviceArea,
                                                                      expression:
                                                                        "dynamicFields.adviceArea"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    name:
                                                                      "adviceArea",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "adviceArea"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    id:
                                                                      "adviceArea",
                                                                    "data-vv-validate-on":
                                                                      "change|blur"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "adviceArea",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select Area"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .adviceArea
                                                                      .memberValue,
                                                                    function(
                                                                      role
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key: role,
                                                                          domProps: {
                                                                            value: role.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              role.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.adviceArea"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.adviceArea')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.adviceArea"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .linkedInProfile &&
                                                  _vm.configureFields
                                                    .linkedInProfile.include &&
                                                  _vm.configureFields
                                                    .linkedInProfile.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "linkedInProfile"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .linkedInProfile
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "linkedInProfile"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .linkedInProfile,
                                                                    expression:
                                                                      "dynamicFields.linkedInProfile"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value: {
                                                                      required:
                                                                        _vm
                                                                          .configureFields
                                                                          .linkedInProfile
                                                                          .require ==
                                                                        true
                                                                          ? true
                                                                          : false,
                                                                      regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                                    },
                                                                    expression:
                                                                      "{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "linkedInProfile"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "linkedInProfile",
                                                                  name:
                                                                    "linkedInProfile",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "linkedInProfile"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .linkedInProfile
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "linkedInProfile",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.linkedInProfile = _vm.sanitizeUrl(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.linkedInProfile"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.linkedInProfile')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.linkedInProfile"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.college &&
                                                  _vm.configureFields.college
                                                    .include &&
                                                  _vm.configureFields.college
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "college"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .college
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "college"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .college,
                                                                    expression:
                                                                      "dynamicFields.college"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "college"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('college')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.college"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "college",
                                                                  name:
                                                                    "college",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "college"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .college
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "college",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.college = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.college"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.college')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.college"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .college2 &&
                                                  _vm.configureFields.college2
                                                    .include &&
                                                  _vm.configureFields.college2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "college2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .college2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "college2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "college2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('college2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .college2,
                                                                      expression:
                                                                        "dynamicFields.college2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    "data-vv-validate-on":
                                                                      "change|blur",
                                                                    id:
                                                                      "college2",
                                                                    name:
                                                                      "college2",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "college2"
                                                                    )
                                                                      ? "true"
                                                                      : "false"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "college2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .college2
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm.college2
                                                                      .memberValue,
                                                                    function(
                                                                      degree,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "college-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: degree.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              degree.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.college2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.college2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.college2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.major &&
                                                  _vm.configureFields.major
                                                    .include &&
                                                  _vm.configureFields.major
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "major"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .major
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "major"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.selectedMajorTemp,
                                                                      expression:
                                                                        "selectedMajorTemp"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id: "major",
                                                                    name:
                                                                      "majorSelect",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "major"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change|blur"
                                                                  },
                                                                  on: {
                                                                    change: [
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        var $$selectedVal = Array.prototype.filter
                                                                          .call(
                                                                            $event
                                                                              .target
                                                                              .options,
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              return o.selected
                                                                            }
                                                                          )
                                                                          .map(
                                                                            function(
                                                                              o
                                                                            ) {
                                                                              var val =
                                                                                "_value" in
                                                                                o
                                                                                  ? o._value
                                                                                  : o.value
                                                                              return val
                                                                            }
                                                                          )
                                                                        _vm.selectedMajorTemp = $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      },
                                                                      _vm.onMajorSelect
                                                                    ]
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .major
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm.major
                                                                      .memberValue,
                                                                    function(
                                                                      m,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "major-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: m.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              m.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "major"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('major')}`"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  type:
                                                                    "hidden",
                                                                  name: "major",
                                                                  "data-vv-validate-on":
                                                                    "change|blur",
                                                                  "aria-describedby": _vm.checkAndValidate1(
                                                                    "major"
                                                                  )
                                                                    ? "required-note"
                                                                    : null
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.majorJoined
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.major"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.major')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.major"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.dynamicFields
                                                                .major &&
                                                              _vm.dynamicFields
                                                                .major.length
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "selected-chips"
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .dynamicFields
                                                                        .major,
                                                                      function(
                                                                        m
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key:
                                                                              "major-chip-" +
                                                                              m,
                                                                            staticClass:
                                                                              "chip"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                m
                                                                              ) +
                                                                                "\n                                                                      "
                                                                            ),
                                                                            _c(
                                                                              "button",
                                                                              {
                                                                                staticClass:
                                                                                  "chip-close",
                                                                                attrs: {
                                                                                  type:
                                                                                    "button",
                                                                                  "aria-label":
                                                                                    "Remove " +
                                                                                    m
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    $event.stopPropagation()
                                                                                    return _vm.removeMajorByValue(
                                                                                      m
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "×"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .classYear &&
                                                  _vm.configureFields.classYear
                                                    .include &&
                                                  _vm.configureFields.classYear
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "year"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .classYear
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "year"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .year,
                                                                    expression:
                                                                      "dynamicFields.year"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "year"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('year')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.year"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "year",
                                                                  name: "year",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "year"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .year
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "year",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.year = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.year"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.year')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.year"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .classYear2 &&
                                                  _vm.configureFields.classYear2
                                                    .include &&
                                                  _vm.configureFields.classYear2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "year2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .classYear2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "year2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "year2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('year2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .year2,
                                                                      expression:
                                                                        "dynamicFields.year2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id: "year2",
                                                                    name:
                                                                      "year2",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "year2"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change|blur"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "year2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .configureFields
                                                                              .classYear2
                                                                              .labelName
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .classYear2
                                                                      .memberValue,
                                                                    function(
                                                                      year,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "year-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: year.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              year.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.year2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.year2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.year2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .organization &&
                                                  _vm.configureFields
                                                    .organization.include &&
                                                  _vm.configureFields
                                                    .organization.include ===
                                                    true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "organization"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .organization
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "organization"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .organization,
                                                                    expression:
                                                                      "dynamicFields.organization"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "organization"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('organization')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.organization"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "organization",
                                                                  name:
                                                                    "organization",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "organization"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .organization
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "organization",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.organization = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.organization"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.organization')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.organization"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.title &&
                                                  _vm.configureFields.title
                                                    .include &&
                                                  _vm.configureFields.title
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for: "role"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .title
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "role"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .role,
                                                                    expression:
                                                                      "dynamicFields.role"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "role"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('role')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.role"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id: "role",
                                                                  name: "role",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "role"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .role
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "role",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.role = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.role"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.role')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.role"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .studentId &&
                                                  _vm.configureFields.studentId
                                                    .include &&
                                                  _vm.configureFields.studentId
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "studentId"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .studentId
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "studentId"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .studentId,
                                                                    expression:
                                                                      "dynamicFields.studentId"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "studentId"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('studentId')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.studentId"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "studentId",
                                                                  name:
                                                                    "studentId",
                                                                  "data-vv-validate-on":
                                                                    "change",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "studentId"
                                                                  )
                                                                    ? "true"
                                                                    : "false"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .studentId
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "studentId",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.studentId = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.studentId"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.studentId')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.studentId"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields.dueDate &&
                                                  _vm.configureFields.dueDate
                                                    .include &&
                                                  _vm.configureFields.dueDate
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "dueDate"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .dueDate
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "dueDate"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("datepicker", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "dueDate"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('dueDate')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                ref:
                                                                  "accessibleDatepicker",
                                                                staticClass:
                                                                  "input-focus template-input-date-picker accessible-datepicker",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.dueDate"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  id: "dueDate",
                                                                  name:
                                                                    "dueDate",
                                                                  format:
                                                                    _vm.DatePickerFormat,
                                                                  disabledDates:
                                                                    _vm.disabledDates,
                                                                  "data-vv-validate-on":
                                                                    "change|blur"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .dueDate,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dynamicFields,
                                                                      "dueDate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dynamicFields.dueDate"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "helper-text template-label mb-0-custom"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Note:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " Does your request have an expiration date after which an answer is no longer desirable?"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.dueDate"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.dueDate')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.dueDate"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-12 mb-17 magic-wand-field-col",
                                                      style:
                                                        _vm.magicWandThemeStyle
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-container-placeholder input-group template-input-text-area template-textarea-v3-t2 magic-wand-icon"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "template-label",
                                                              attrs: {
                                                                for: "prompt"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .configureFields
                                                                    .question
                                                                    .labelName
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-symbol"
                                                            },
                                                            [_vm._v(" *")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.prompt"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.prompt')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error-message-textarea error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.prompt"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "char-counter-input"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  attrs: {
                                                                    "aria-live":
                                                                      "polite"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      class: {
                                                                        "char-count-error":
                                                                          _vm.underMinCount
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.textCount
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "  / " +
                                                                      _vm._s(
                                                                        _vm.textMax
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " character count."
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "placeholder-overlay input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2",
                                                            class: {
                                                              "magicwand-enabled": !_vm.magicWandEnabled
                                                            },
                                                            style:
                                                              _vm.placeholderStyle,
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                this.requestForm
                                                                  .question
                                                              )
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.handlePlaceholderClick
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "textarea-magic-container magic-wand-field-input magic-wand-icon"
                                                            },
                                                            [
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.ask
                                                                        .text,
                                                                    expression:
                                                                      "ask.text"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "required|max:2000|min:200",
                                                                    expression:
                                                                      "'required|max:2000|min:200'",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                ref:
                                                                  "questionPlaceholderRef",
                                                                staticClass:
                                                                  "form-control pt-input request-form-question-textarea",
                                                                class: {
                                                                  "request-form-error-border question-error-present": _vm.errors.has(
                                                                    "step-1.prompt"
                                                                  )
                                                                },
                                                                style: !_vm.magicWandEnabled
                                                                  ? "padding: 8px !important"
                                                                  : "padding: 37px 8px 8px 8px !important",
                                                                attrs: {
                                                                  id: "prompt",
                                                                  "aria-label":
                                                                    "Question",
                                                                  name:
                                                                    "prompt",
                                                                  rows: "15",
                                                                  maxlength:
                                                                    _vm.textMax,
                                                                  "aria-required": true,
                                                                  "data-vv-validate-on":
                                                                    "change|blur",
                                                                  "aria-live":
                                                                    "polite"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.ask.text
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.ask,
                                                                        "text",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    _vm.countdown,
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.ask.text = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ],
                                                                  focus:
                                                                    _vm.handleQuestionFocusEvent,
                                                                  blur:
                                                                    _vm.handleQuestionBlurEvent
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.magicWandEnabled
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "magic-wand-link-textarea magic-wand-link-accent",
                                                                      class: {
                                                                        "magic-wand-link-active": _vm.isExamplesOpen(
                                                                          "text"
                                                                        )
                                                                      },
                                                                      attrs: {
                                                                        role:
                                                                          "button",
                                                                        "aria-label":
                                                                          "View Examples",
                                                                        href:
                                                                          "javascript:void(0);"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.toggleMagicWandExamples(
                                                                            "text"
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "View Examples\n                                                                "
                                                                      ),
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "magic-wand-img magic-wand-img-panel",
                                                                          attrs: {
                                                                            src:
                                                                              _vm.magicWandIcon,
                                                                            alt:
                                                                              "",
                                                                            width:
                                                                              "20",
                                                                            height:
                                                                              "20"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.magicWandEnabled &&
                                                      _vm.isExamplesOpen("text")
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "magic-wand-examples-anchor"
                                                            },
                                                            [
                                                              _c(
                                                                "MagicWandExamplesPanel",
                                                                {
                                                                  attrs: {
                                                                    examples: _vm.getWizardExamplesForField(
                                                                      "text"
                                                                    ),
                                                                    "field-label": _vm.getMagicWandFieldLabel(
                                                                      "text"
                                                                    ),
                                                                    loading:
                                                                      _vm.wizardExamplesLoading,
                                                                    "magic-wand-icon":
                                                                      _vm.magicWandIcon,
                                                                    "accent-color":
                                                                      _vm.magicWandAccentColor,
                                                                    "field-has-text": _vm.magicWandFieldHasText(
                                                                      "text"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    close:
                                                                      _vm.closeMagicWandExamples,
                                                                    "use-example": function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.insertMagicWandExample(
                                                                        "text",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .referrer &&
                                                  _vm.configureFields.referrer
                                                    .include &&
                                                  _vm.configureFields.referrer
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "referrer"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .referrer
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "referrer"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dynamicFields
                                                                        .referrer,
                                                                    expression:
                                                                      "dynamicFields.referrer"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate.continues",
                                                                    value:
                                                                      "" +
                                                                      _vm.checkAndValidate1(
                                                                        "referrer"
                                                                      ),
                                                                    expression:
                                                                      "`${checkAndValidate1('referrer')}`",
                                                                    modifiers: {
                                                                      continues: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control input-value pt-input input-focus",
                                                                class: {
                                                                  "request-form-error-border": _vm.errors.has(
                                                                    "step-1.referrer"
                                                                  )
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "referrer",
                                                                  name:
                                                                    "referrer",
                                                                  placeholder:
                                                                    "",
                                                                  "aria-required": _vm.checkAndValidate1(
                                                                    "referrer"
                                                                  )
                                                                    ? "true"
                                                                    : "false",
                                                                  "data-vv-validate-on":
                                                                    "change"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .dynamicFields
                                                                      .referrer
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "referrer",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                    function(
                                                                      e
                                                                    ) {
                                                                      return (_vm.dynamicFields.referrer = _vm.sanitizeInput(
                                                                        e.target
                                                                          .value
                                                                      ))
                                                                    }
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.referrer"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.referrer')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.referrer"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.configureFields
                                                    .referrer2 &&
                                                  _vm.configureFields.referrer2
                                                    .include &&
                                                  _vm.configureFields.referrer2
                                                    .include === true
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "template-label",
                                                                  attrs: {
                                                                    for:
                                                                      "referrer2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .configureFields
                                                                        .referrer2
                                                                        .labelName
                                                                    )
                                                                  ),
                                                                  _vm.checkAndValidate1(
                                                                    "referrer2"
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-symbol"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " *"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "" +
                                                                        _vm.checkAndValidate1(
                                                                          "referrer2"
                                                                        ),
                                                                      expression:
                                                                        "`${checkAndValidate1('referrer2')}`"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .dynamicFields
                                                                          .referrer2,
                                                                      expression:
                                                                        "dynamicFields.referrer2"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                                  attrs: {
                                                                    id:
                                                                      "referrer2",
                                                                    name:
                                                                      "referrer2",
                                                                    "aria-required": _vm.checkAndValidate1(
                                                                      "referrer2"
                                                                    )
                                                                      ? "true"
                                                                      : "false",
                                                                    "data-vv-validate-on":
                                                                      "change|blur"
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$selectedVal = Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function(
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                      _vm.$set(
                                                                        _vm.dynamicFields,
                                                                        "referrer2",
                                                                        $event
                                                                          .target
                                                                          .multiple
                                                                          ? $$selectedVal
                                                                          : $$selectedVal[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      staticStyle: {
                                                                        display:
                                                                          "none"
                                                                      },
                                                                      attrs: {
                                                                        value:
                                                                          "",
                                                                        selected:
                                                                          "",
                                                                        disabled:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm
                                                                      .referrer2
                                                                      .memberValue,
                                                                    function(
                                                                      degree,
                                                                      idx
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "referrer-" +
                                                                            idx,
                                                                          domProps: {
                                                                            value: degree.trim()
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              degree.trim()
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "step-1.referrer2"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('step-1.referrer2')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "error"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.errors.first(
                                                                        "step-1.referrer2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.configureFields.disclaimer &&
                                              _vm.configureFields.disclaimer
                                                .include &&
                                              _vm.configureFields.disclaimer
                                                .include === true
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row mlr0" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-group disclaimer"
                                                        },
                                                        [
                                                          _c(
                                                            "md-checkbox",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate.continues",
                                                                  value:
                                                                    "" +
                                                                    _vm.checkAndValidate1(
                                                                      "disclaimer"
                                                                    ),
                                                                  expression:
                                                                    "`${checkAndValidate1('disclaimer')}`",
                                                                  modifiers: {
                                                                    continues: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control template-checkbox pt-0",
                                                              attrs: {
                                                                tabindex: "1",
                                                                name:
                                                                  "disclaimer",
                                                                id:
                                                                  "disclaimer",
                                                                "data-vv-validate-on":
                                                                  "change"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateDisclaimer()
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .dynamicFields
                                                                    .disclaimer,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.dynamicFields,
                                                                    "disclaimer",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "dynamicFields.disclaimer"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                            " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .configureFields
                                                                      .disclaimer
                                                                      .labelName
                                                                  ) +
                                                                  "\n                                                            "
                                                              ),
                                                              _vm.checkAndValidate1(
                                                                "disclaimer"
                                                              )
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-symbol"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " *"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "step-1.disclaimer"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('step-1.disclaimer')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "error error-mt-2 template-checkbox-error"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "step-1.disclaimer"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.configureFields.disclaimer &&
                                              _vm.configureFields.dueDate
                                                .include === false
                                                ? _c("div", {
                                                    staticClass:
                                                      "template-mb-35"
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center-xs float-right"
                                                },
                                                [
                                                  !_vm.communityHasInterests
                                                    ? [
                                                        _c(
                                                          "md-button",
                                                          {
                                                            staticClass:
                                                              "btn btn_info template-review-submit template-button",
                                                            style:
                                                              _vm.styleSubmitBtn,
                                                            attrs: {
                                                              type: "button",
                                                              disabled:
                                                                _vm.loading,
                                                              "aria-label":
                                                                "Next.",
                                                              "aria-busy":
                                                                _vm.loading
                                                            },
                                                            on: {
                                                              click: _vm.onClick
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                            Next\n                                                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-block text-right mlr0 text-center-xs"
                                                          },
                                                          [
                                                            _c(
                                                              "md-button",
                                                              {
                                                                staticClass:
                                                                  "btn_info template-review-submit template-button",
                                                                style:
                                                                  _vm.styleSubmitBtn,
                                                                attrs: {
                                                                  type: "submit"
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.onClick
                                                                }
                                                              },
                                                              [_vm._v("Next")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSecondPage
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeup-header"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Ready for your close-up?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.community.content &&
                                              _vm.community.content
                                                .requestFormWizardPage3
                                                ? _c("p", {
                                                    staticClass:
                                                      "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.sanitizeListHTML(
                                                          _vm.community.content
                                                            .requestFormWizardPage3
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                    },
                                                    [
                                                      _vm._v(
                                                        'Here\'s what advisors will receive. Need to make a revision? Simply click "Back" and edit.'
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass:
                                                  "template-hr-custom"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "about-feedbackreq"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "template-request-review"
                                                    },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          attrs: {
                                                            "aria-level": "2",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.first
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                this.ask.last
                                                              )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticStyle: {
                                                            color: "#000001"
                                                          },
                                                          attrs: {
                                                            "aria-level": "3",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask
                                                                .dynamicFields
                                                                .college &&
                                                                this.ask
                                                                  .dynamicFields
                                                                  .college != ""
                                                                ? this.ask
                                                                    .dynamicFields
                                                                    .college
                                                                : this.ask
                                                                    .dynamicFields
                                                                    .college2 &&
                                                                  this.ask
                                                                    .dynamicFields
                                                                    .college2 !=
                                                                    ""
                                                                ? this.ask
                                                                    .dynamicFields
                                                                    .college2
                                                                : ""
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h2",
                                                        {
                                                          attrs: {
                                                            "aria-level": "2",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.subject
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-color"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.text
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row back-next-step-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-left"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-edit template-button mb-10",
                                                              style:
                                                                _vm.styleEditBtn,
                                                              attrs: {
                                                                tabindex: "0",
                                                                role: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.goToFirst()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Back")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-right"
                                                        },
                                                        [
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-submit template-button",
                                                              style:
                                                                _vm.styleSubmitBtn,
                                                              attrs: {
                                                                type: "button",
                                                                disabled:
                                                                  _vm.disabledBtn ==
                                                                  1
                                                                    ? true
                                                                    : false
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.save()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Submit")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isThirdPage &&
                                      _vm.configureFields.interest &&
                                      _vm.configureFields.interest.include
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "interests-header",
                                                    tabindex: "-1"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Choose 3-5 interests you have."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content interest-description-display"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.configureFields
                                                        .interest.description
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("fieldset", [
                                                _c(
                                                  "legend",
                                                  { staticClass: "sr-only" },
                                                  [
                                                    _vm._v(
                                                      "Select your interests"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row text-center interest-container"
                                                  },
                                                  _vm._l(
                                                    _vm.randomInterest,
                                                    function(
                                                      randomInterestItem
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: randomInterestItem,
                                                          ref:
                                                            "checkboxMainRef",
                                                          refInFor: true,
                                                          staticClass:
                                                            "col-md-4 col-sm-4 col-xs-6 width100"
                                                        },
                                                        [
                                                          _c(
                                                            "md-checkbox",
                                                            {
                                                              staticClass:
                                                                "my-round-checkbox",
                                                              attrs: {
                                                                value: randomInterestItem,
                                                                name: randomInterestItem,
                                                                "aria-describedby":
                                                                  "interest-desc-" +
                                                                  randomInterestItem
                                                                    .replace(
                                                                      /\s+/g,
                                                                      "-"
                                                                    )
                                                                    .toLowerCase()
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateAriaChecked(
                                                                    randomInterestItem
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.selectedInterestList,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.selectedInterestList = $$v
                                                                },
                                                                expression:
                                                                  "selectedInterestList"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "interest-desc-" +
                                                                      randomInterestItem
                                                                        .replace(
                                                                          /\s+/g,
                                                                          "-"
                                                                        )
                                                                        .toLowerCase()
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      randomInterestItem
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row back-next-step-2 pr-25 pl-25"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center-xs float-left"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-edit template-button mb-10",
                                                          style:
                                                            _vm.styleEditBtn,
                                                          attrs: {
                                                            tabindex: "0",
                                                            role: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToFirst()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Back\n                                              "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center-xs float-right"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-submit template-button",
                                                          style:
                                                            _vm.styleSubmitBtn,
                                                          attrs: {
                                                            type: "button",
                                                            disabled:
                                                              _vm.loading,
                                                            "aria-label":
                                                              "Next: We're crafting a thoughtful question to present to your advisor. Clickable",
                                                            "aria-busy":
                                                              _vm.loading
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.goToFourth()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        Next\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isFourthPage && _vm.athenaEnabledQC
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "athenaQuestion-header"
                                                  }
                                                },
                                                [_vm._v("What do you think?")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content interest-description-display"
                                                },
                                                [
                                                  _vm._v(
                                                    "We've crafted a question for you based on what you shared."
                                                  ),
                                                  _c("br")
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.loading
                                                ? [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "AthenaQuestionSkeleton",
                                                          {
                                                            attrs: {
                                                              "is-visible":
                                                                _vm.loading
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "round-question-container"
                                                      },
                                                      [
                                                        _c(
                                                          "h2",
                                                          {
                                                            staticClass:
                                                              "template-content-bold"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .dynamicFields
                                                                  .first
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .dynamicFields
                                                                    .last
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "fs_15 lh_111",
                                                              staticStyle: {
                                                                "font-family":
                                                                  "'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif",
                                                                "text-align":
                                                                  "left",
                                                                "font-size":
                                                                  "18px",
                                                                color:
                                                                  "#000001",
                                                                "line-height":
                                                                  "16px"
                                                              },
                                                              attrs: {
                                                                role:
                                                                  "Presentation"
                                                              }
                                                            },
                                                            [
                                                              _vm.dynamicFields
                                                                .college ||
                                                              _vm.dynamicFields
                                                                .college2 ||
                                                              _vm.school
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .dynamicFields
                                                                          .college ||
                                                                          _vm
                                                                            .dynamicFields
                                                                            .college2 ||
                                                                          _vm.school
                                                                      )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.dynamicFields
                                                                .year ||
                                                              _vm.dynamicFields
                                                                .year2 ||
                                                              _vm.year
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " (" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .dynamicFields
                                                                            .year ||
                                                                            _vm
                                                                              .dynamicFields
                                                                              .year2 ||
                                                                            _vm.year
                                                                        ) +
                                                                        ")"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _vm.gaiaAnswer &&
                                                        !_vm.isEditing
                                                          ? _c("p", {
                                                              staticClass:
                                                                "custom-content-2",
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  _vm.sanitizeInput(
                                                                    _vm.gaiaFormattedAnswer
                                                                  )
                                                                )
                                                              }
                                                            })
                                                          : _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.gaiaAnswer,
                                                                  expression:
                                                                    "gaiaAnswer"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "editable-input custom-content-2",
                                                              staticStyle: {
                                                                "text-align":
                                                                  "justify"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                rows: "15",
                                                                "aria-label":
                                                                  "Edit your question response"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.gaiaAnswer
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.gaiaAnswer =
                                                                    $event.target.value
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row back-next-step-2 pr-25 pl-25"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-center-xs float-left",
                                                            staticStyle: {
                                                              display: "flex",
                                                              gap: "30px"
                                                            }
                                                          },
                                                          [
                                                            !_vm.isEditing
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn_info template-review-edit template-button mb-10",
                                                                    style:
                                                                      _vm.styleEditBtn,
                                                                    attrs: {
                                                                      "aria-label": _vm.isUndo
                                                                        ? "Undo"
                                                                        : "Redo",
                                                                      role:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.toggleQuestionVersion()
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          _vm.isUndo
                                                                            ? "Undo"
                                                                            : "Redo"
                                                                        ) +
                                                                        "\n                                              "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn_info template-review-edit template-button mb-10",
                                                                style:
                                                                  _vm.styleEditBtn,
                                                                attrs: {
                                                                  role: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleEdit()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.isEditing
                                                                        ? "Save"
                                                                        : "Edit"
                                                                    ) +
                                                                    "\n                                              "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-center-xs float-right"
                                                          },
                                                          [
                                                            [
                                                              !_vm.isEditing
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn_info template-review-submit template-button",
                                                                      style:
                                                                        _vm.styleSubmitBtn,
                                                                      attrs: {
                                                                        type:
                                                                          "button",
                                                                        disabled:
                                                                          _vm.isEditing,
                                                                        "aria-label":
                                                                          "Submit your question.",
                                                                        "aria-busy":
                                                                          _vm.loading
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateAndSubmit()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            Submit\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isFourthPage &&
                                      _vm.questionCoachEnabled
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeup-header"
                                                  }
                                                },
                                                [_vm._v("Great Start")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                },
                                                [
                                                  _vm._v(
                                                    "We've analyzed your question and have a few suggestions to make sure you'll get a response."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass:
                                                  "template-hr-custom"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "about-feedbackreq"
                                                },
                                                [
                                                  _vm.questionCoachScore <= 0
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "MidsizeSkeleton",
                                                            {
                                                              attrs: {
                                                                "is-visible": true
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-request-review feedback-card",
                                                          style: {
                                                            backgroundColor:
                                                              _vm.feedback
                                                                .color +
                                                              " !important"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "feedback-content"
                                                            },
                                                            [
                                                              _c(
                                                                "h2",
                                                                {
                                                                  staticClass:
                                                                    "coach-header score-header feedback-title"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .feedback
                                                                          .text
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .coachFeedback
                                                                      .guidance
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _vm.coachChecklist
                                                                ? _c(
                                                                    "ul",
                                                                    {
                                                                      staticClass:
                                                                        "feedback-checklist"
                                                                    },
                                                                    _vm._l(
                                                                      _vm.checklistItems,
                                                                      function(
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          {
                                                                            key:
                                                                              item.key,
                                                                            staticClass:
                                                                              "checklist-item",
                                                                            class: {
                                                                              checked:
                                                                                item.checked,
                                                                              unchecked: !item.checked
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "checkbox-icon",
                                                                                class: {
                                                                                  checked:
                                                                                    item.checked
                                                                                }
                                                                              },
                                                                              [
                                                                                item.checked
                                                                                  ? _c(
                                                                                      "svg",
                                                                                      {
                                                                                        attrs: {
                                                                                          width:
                                                                                            "20",
                                                                                          height:
                                                                                            "20",
                                                                                          viewBox:
                                                                                            "0 0 20 20",
                                                                                          fill:
                                                                                            "none",
                                                                                          xmlns:
                                                                                            "http://www.w3.org/2000/svg"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "rect",
                                                                                          {
                                                                                            attrs: {
                                                                                              width:
                                                                                                "20",
                                                                                              height:
                                                                                                "20",
                                                                                              rx:
                                                                                                "4",
                                                                                              fill:
                                                                                                "#10B981"
                                                                                            }
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "path",
                                                                                          {
                                                                                            attrs: {
                                                                                              d:
                                                                                                "M6 10L9 13L14 7",
                                                                                              stroke:
                                                                                                "white",
                                                                                              "stroke-width":
                                                                                                "2",
                                                                                              "stroke-linecap":
                                                                                                "round",
                                                                                              "stroke-linejoin":
                                                                                                "round"
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "svg",
                                                                                      {
                                                                                        attrs: {
                                                                                          width:
                                                                                            "20",
                                                                                          height:
                                                                                            "20",
                                                                                          viewBox:
                                                                                            "0 0 20 20",
                                                                                          fill:
                                                                                            "none",
                                                                                          xmlns:
                                                                                            "http://www.w3.org/2000/svg"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "rect",
                                                                                          {
                                                                                            attrs: {
                                                                                              width:
                                                                                                "20",
                                                                                              height:
                                                                                                "20",
                                                                                              rx:
                                                                                                "4",
                                                                                              fill:
                                                                                                "#E5E7EB",
                                                                                              stroke:
                                                                                                "#D1D5DB",
                                                                                              "stroke-width":
                                                                                                "1"
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "checklist-text",
                                                                                class: {
                                                                                  "text-muted": !item.checked
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.label
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.coachChecklist &&
                                                              !_vm.isMessageReady &&
                                                              _vm.coachFeedback
                                                                .improvements &&
                                                              _vm.coachFeedback
                                                                .improvements
                                                                .length
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "improvements-section"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h3",
                                                                        {
                                                                          staticClass:
                                                                            "improvements-title"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Suggestions to improve:"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "ul",
                                                                        {
                                                                          staticClass:
                                                                            "improvements-list"
                                                                        },
                                                                        _vm._l(
                                                                          _vm
                                                                            .coachFeedback
                                                                            .improvements,
                                                                          function(
                                                                            improvement,
                                                                            index
                                                                          ) {
                                                                            return _c(
                                                                              "li",
                                                                              {
                                                                                key:
                                                                                  "improvement-" +
                                                                                  index,
                                                                                staticClass:
                                                                                  "improvement-item"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      improvement
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "feedback-emoji-wrapper"
                                                            },
                                                            [
                                                              _vm.coachChecklist
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "score-circle"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "svg",
                                                                        {
                                                                          attrs: {
                                                                            width:
                                                                              "80",
                                                                            height:
                                                                              "80",
                                                                            viewBox:
                                                                              "0 0 80 80"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "circle",
                                                                            {
                                                                              attrs: {
                                                                                cx:
                                                                                  "40",
                                                                                cy:
                                                                                  "40",
                                                                                r:
                                                                                  "35",
                                                                                fill:
                                                                                  "white",
                                                                                stroke:
                                                                                  "#E5E7EB",
                                                                                "stroke-width":
                                                                                  "2"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "text",
                                                                            {
                                                                              attrs: {
                                                                                x:
                                                                                  "40",
                                                                                y:
                                                                                  "45",
                                                                                "text-anchor":
                                                                                  "middle",
                                                                                "font-size":
                                                                                  "24",
                                                                                "font-weight":
                                                                                  "bold",
                                                                                fill:
                                                                                  "#1F2937"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            " +
                                                                                  _vm._s(
                                                                                    _vm.checklistCompletionCount
                                                                                  ) +
                                                                                  "/" +
                                                                                  _vm._s(
                                                                                    _vm.checklistTotalCount
                                                                                  ) +
                                                                                  "\n                                                        "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "text",
                                                                            {
                                                                              attrs: {
                                                                                x:
                                                                                  "40",
                                                                                y:
                                                                                  "58",
                                                                                "text-anchor":
                                                                                  "middle",
                                                                                "font-size":
                                                                                  "10",
                                                                                fill:
                                                                                  "#6B7280"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            COMPLETE\n                                                        "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "feedback-emoji big-emoji"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .feedback
                                                                            .emoji
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "feedback-text-emoji"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .feedback
                                                                        .text_emoji
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: { for: "askText" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Edit your message below - and review changes"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.ask.text,
                                                        expression: "ask.text"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "editable-input custom-content-2",
                                                    staticStyle: {
                                                      "text-align": "justify"
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      rows: "15",
                                                      "aria-label":
                                                        "Edit your question response"
                                                    },
                                                    domProps: {
                                                      value: _vm.ask.text
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.ask,
                                                          "text",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "back-next-step-2",
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                        "align-items": "center",
                                                        gap: "10px",
                                                        "flex-wrap": "nowrap"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn_info template-review-edit template-button",
                                                          style:
                                                            _vm.styleEditBtn,
                                                          attrs: {
                                                            role: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.communityHasInterests
                                                                ? _vm.goToThird()
                                                                : _vm.goToPage(
                                                                    1,
                                                                    0
                                                                  )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                Back\n                                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "10px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-edit template-button",
                                                              style:
                                                                _vm.styleEditBtn,
                                                              attrs: {
                                                                role: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.questionCoach()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                Review\n                                            "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-submit template-button",
                                                              style:
                                                                _vm.styleSubmitBtn,
                                                              attrs: {
                                                                type: "button",
                                                                disabled: !_vm.isMessageReady
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.save()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                Submit\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm.isFourthPage &&
                                          !_vm.athenaEnabledQC
                                        ? _c(
                                            "div",
                                            { staticClass: "tab_inn" },
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "template-title",
                                                  attrs: {
                                                    id: "closeup-header"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Ready for your close-up?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.community.content &&
                                              _vm.community.content
                                                .requestFormWizardPage3
                                                ? _c("p", {
                                                    staticClass:
                                                      "box-sub-heading mb35 custom-content request-form-title-anchor-tab",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.sanitizeListHTML(
                                                          _vm.community.content
                                                            .requestFormWizardPage3
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "box-sub-heading mb35 custom-content request-form-title-anchor-tab"
                                                    },
                                                    [
                                                      _vm._v(
                                                        'Here\'s what advisors will receive. Need to make a revision? Simply click "Back" and edit.'
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass:
                                                  "template-hr-custom"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "about-feedbackreq"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "template-request-review"
                                                    },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          attrs: {
                                                            "aria-level": "2",
                                                            role: "Presentation"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.dynamicFields
                                                                .first
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm
                                                                  .dynamicFields
                                                                  .last
                                                              )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "fs_15 lh_111",
                                                            staticStyle: {
                                                              "font-family":
                                                                "'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif",
                                                              "text-align":
                                                                "left",
                                                              "font-size":
                                                                "18px",
                                                              color: "#777479",
                                                              "line-height":
                                                                "22px"
                                                            },
                                                            attrs: {
                                                              role:
                                                                "Presentation"
                                                            }
                                                          },
                                                          [
                                                            _vm.dynamicFields
                                                              .college ||
                                                            _vm.dynamicFields
                                                              .college2 ||
                                                            _vm.school
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .dynamicFields
                                                                        .college ||
                                                                        _vm
                                                                          .dynamicFields
                                                                          .college2 ||
                                                                        _vm.school
                                                                    )
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.dynamicFields
                                                              .year ||
                                                            _vm.dynamicFields
                                                              .year2 ||
                                                            _vm.year
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " (" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .dynamicFields
                                                                          .year ||
                                                                          _vm
                                                                            .dynamicFields
                                                                            .year2 ||
                                                                          _vm.year
                                                                      ) +
                                                                      ")"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-color"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.ask.text
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row back-next-step-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-left"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-edit template-button mb-10",
                                                              style:
                                                                _vm.styleEditBtn,
                                                              attrs: {
                                                                role: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.communityHasInterests
                                                                    ? _vm.goToThird()
                                                                    : _vm.goToPage(
                                                                        1,
                                                                        0
                                                                      )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Back")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-lg-6 col-md-6 col-sm-6 text-center-xs float-right text-right-md"
                                                        },
                                                        [
                                                          _c(
                                                            "md-button",
                                                            {
                                                              staticClass:
                                                                "btn btn_info template-review-submit template-button",
                                                              style:
                                                                _vm.styleSubmitBtn,
                                                              attrs: {
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.save()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Submit")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isBeforeRequest && !_vm.invalidMember
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation"
                                  },
                                  [
                                    _c(
                                      "h1",
                                      {
                                        staticClass:
                                          "box-heading thankyou-template-title",
                                        attrs: { id: "whatsnext-header" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    So what's next?\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { color: "#000001" } },
                                      [
                                        _vm.community.content &&
                                        _vm.community.content
                                          .requestPageThankYou
                                          ? _c("div", {
                                              staticClass:
                                                "box-sub-heading text-left content-textleft thankyou-custom-content",
                                              attrs: { tabindex: "0" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.sanitizeListHTML(
                                                    _vm.community.content
                                                      .requestPageThankYou
                                                  )
                                                )
                                              },
                                              on: {
                                                "!click": function($event) {
                                                  return _vm.handleThankYouResourceClick.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "box-sub-heading text-left content-textleft thankyou-custom-content",
                                                attrs: { tabindex: "0" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        We will now recruit the right experts to help you.\n                                    "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm.isLoadingResources
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thankyou-loader-wrapper mt-4",
                                                attrs: { "aria-live": "polite" }
                                              },
                                              [
                                                _c("CustomThankYouSkeleton", {
                                                  attrs: { "is-visible": true }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showErrorMessage
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thankyou-status-message mt-4",
                                                staticStyle: {
                                                  padding: "12px 16px",
                                                  "border-radius": "4px",
                                                  border: "1px solid #f5c2c7",
                                                  background: "#f8d7da",
                                                  color: "#611a15"
                                                },
                                                attrs: {
                                                  role: "alert",
                                                  tabindex: "0"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.errorMessage ||
                                                        "We were unable to submit your request. Please try again."
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showSuccessMessage
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-4 text-left" },
                                              [
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn_info template-review-submit template-button",
                                                    style: _vm.styleSubmitBtn,
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click:
                                                        _vm.askAnotherQuestion
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            Ask Another Question\n                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isBeforeRequest && _vm.invalidMember
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "header-text common-space-from-logo text-left unsubscribepage-thankumsg"
                                  },
                                  [
                                    _c(
                                      "h1",
                                      {
                                        staticClass:
                                          "box-heading thankyou-template-title"
                                      },
                                      [_vm._v("Ooops. We're really sorry.")]
                                    ),
                                    _vm._v(" "),
                                    _vm.community.content &&
                                    _vm.community.content.requestPageThankYou
                                      ? _c("div", {
                                          staticClass:
                                            "box-sub-heading text-left content-textleft thankyou-custom-content",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.sanitizeListHTML(
                                                _vm.finalInvalidMemberMessage
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("footer", [
                      _c(
                        "ul",
                        { staticClass: "list-inline text-center footer-links" },
                        [
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.landingPageURL &&
                            _vm.community.content.landingPageURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content.landingPageURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.termsConditionsURL &&
                            _vm.community.content.termsConditionsURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content
                                          .termsConditionsURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.unsubscribePageURL &&
                            _vm.community.content.unsubscribePageURL.length
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      tabindex: "0",
                                      href:
                                        _vm.community.content
                                          .unsubscribePageURL,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Opt Out")]
                                )
                              : _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [_vm._v("Opt Out")]
                                )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "unsubscribe-community-logo" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                (_vm.community.content &&
                                  _vm.community.content.landingPageURL) ||
                                "https://www.protopia.co",
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                tabindex: "0",
                                src: _vm.footerLogoURL,
                                alt:
                                  "Community Logo of " +
                                  (_vm.community &&
                                  _vm.community.content &&
                                  _vm.community.content.parameter4
                                    ? _vm.community.content.parameter4
                                    : (_vm.community && _vm.community.name) ||
                                      "Community")
                              }
                            }),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Protopia - Visit our site")
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-066672ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066672ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityRequestPageV1Short.vue
// module id = null
// module chunks = 